import {
    CONTAINER_ASSIGNED_STATE,
    CONTAINER_MOVE_STATE,
    HEAVY_CART,
    KG_TO_POUND,
    delay,
} from "./Util.js";
import {
    ReportMetadata,
    Cart,
    ContainerReportMetadata,
} from "./ReportViewSchema.js";
import {getPackageWeightInCartIfAny} from "./GetCartPackageHistory.js";

export const getPickReportMetadata = (result) => {
    return new ReportMetadata(
        result.bagCount,
        result.maxBagWt,
        (result.totalWt === 0 || result.bagCount === 0) ? 0 : result.totalWt / result.bagCount,
        result.totalWt,
        result.heavyCount
    );
}

export const getContainerInsightReportMetadata = (result) => {
    return new ContainerReportMetadata(
        result.bagCount,
        result.packageCount,
        result.maxBagWt,
        result.maxPackageWt,
        (result.totalWt === 0 || result.bagCount === 0) ? 0 : result.totalWt / result.bagCount,
        result.totalWt,
        result.totalWt / result.packageCount
    );
}

export const generateStageReportMetadata = async (carts, bagReportMap, stagedBags) => {
    let assignedCarts = carts.filter((cart) => (cart.containerState === CONTAINER_ASSIGNED_STATE))
    let movedCarts = carts.filter((cart) => (cart.containerState === CONTAINER_MOVE_STATE))
    let cartReport = []
    for (const cart of movedCarts) {
        let bagsInCart = stagedBags.filter(
            (bag) => bag.scanLocation === cart.containerLabel
        );
        let result = bagsInCart.reduce(
            (acc, curr) => ({
                maxBagWt: Math.max(
                    acc.maxBagWt,
                    bagReportMap[curr.containerLabel].totalWeight
                ),
                cartWt: acc.cartWt + bagReportMap[curr.containerLabel].totalWeight,
                bagCount: acc.bagCount + 1,
            }),
            {maxBagWt: 0, cartWt: 0, bagCount: 0}
        );
        if (result.bagCount < 9) {
            let startTimeForCart = getStartTimeForCart(assignedCarts, cart)
            const packageWeightInCart = await fetchContainerPackageWeight(cart.containerLabel, cart.stationCode, startTimeForCart, cart.eventTime);
            result.cartWt = result.cartWt + packageWeightInCart;
            await wait(100)
        }
        cartReport.push(new Cart(result.maxBagWt, result.cartWt, result.bagCount));
    }

    let cartReportResult = cartReport.reduce(
        (acc, curr) => ({
            maxWt: Math.max(acc.maxWt, curr.cartWt),
            totalWt: acc.totalWt + curr.cartWt,
            count: acc.count + 1,
            heavyCount: acc.heavyCount + ((curr.cartWt * KG_TO_POUND) > HEAVY_CART ? 1 : 0)
        }),
        {maxWt: 0, totalWt: 0, count: 0, heavyCount: 0}
    );

    let cartReportMetadata = new ReportMetadata(
        cartReportResult.count,
        cartReportResult.maxWt,
        cartReportResult.totalWt / cartReportResult.count,
        cartReportResult.totalWt,
        cartReportResult.heavyCount
    );
    return cartReportMetadata;
};

const fetchContainerPackageWeight = async (
    containerLabel,
    nodeId,
    opsClockStartTime,
    opsClockEndTime
) => {
    return await getPackageWeightInCartIfAny(
        containerLabel,
        nodeId,
        opsClockStartTime,
        opsClockEndTime
    );
};

const wait = async (time) => {
    return delay(time);
}
const getStartTimeForCart = (assignedCarts, cart) => {
    for (const assignedCart of assignedCarts) {
        if (assignedCart.containerLabel === cart.containerLabel) {
            return assignedCart.eventTime;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/detailPages/associateDetails/safetyReport/ContainerReport.js